import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { TournamentLevel, TOURNAMENT_LEVELS } from "../types";

interface TournamentLevelSelectorProps {
  value: TournamentLevel;
  onChange: (level: TournamentLevel) => void;
  fullWidth?: boolean;
  label?: string;
  excludeAll?: boolean; // If true, don't show "All" option
}

export default function TournamentLevelSelector({
  value,
  onChange,
  fullWidth = false,
  label = "Tournament Level",
  excludeAll = false,
}: TournamentLevelSelectorProps) {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value as TournamentLevel)}
      >
        {!excludeAll && (
          <MenuItem value="All">
            <em>All Levels</em>
          </MenuItem>
        )}
        {TOURNAMENT_LEVELS.map((level) => (
          <MenuItem key={level} value={level}>
            {level}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
